"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _antd = require("antd");

var _react = _interopRequireDefault(require("react"));

require("../select/SelectComponent.scss");

var _excluded = ["className", "dropdownClassName"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function MultiSelect(_ref) {
  var className = _ref.className,
      dropdownClassName = _ref.dropdownClassName,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_antd.Select, _extends({
    "data-testid": "select-component",
    className: "".concat(className, " iiht-ant-select"),
    dropdownClassName: "iiht-ant-select-dropdown",
    style: {
      width: props !== null && props !== void 0 && props.width ? props === null || props === void 0 ? void 0 : props.width : 260
    },
    getPopupContainer: function getPopupContainer() {
      return document.getElementById("app-container");
    }
  }, props));
}

var _default = MultiSelect;
exports["default"] = _default;